export default {
  lang: "Español",

  // Dextra Content
  welcome: "Consulta de video Dextra",
  s_services: "Servicios Dextra",
  s_tracking: "Seguimiento de servicios",
  s_record: "Servicios de documentos",
  s_redirect: "Redirección de servicio",
  s_adress: "Servicios de dirección",
  s_feedback: "Soporte al cliente",
  privacy: "Tu privacidad es importante. Las conversaciones se tratan confidencialmente y no se graban.",
  agentAvailability: "Disponibilidad del agente",
  available: "Disponible",
  unavailable: "No disponible",
  connecting_title: "Conectando...",
  connecting_message: "Por favor espera un momento.",
  cancel: "Cancelar",
  button_start: "Comenzar aquí"
}
